export * from './is-page-template-content-entry'
